// page one data
export const PAGEONE = "PAGEONE";

// page two data
export const PAGETWO = "PAGETWO";

// page three data
export const PAGETHREE = "PAGETHREE";
